import { useEvents } from "@/hooks/useConflictData";
import { useAuth } from "@/hooks/useAuth";
import { useMemo } from "react";

const EVENT_ICONS: Record<string, string> = {
  missile: "🚀",
  drone: "🛩️",
  air_raid: "🚨",
  explosion: "💥",
  movement: "🔄",
};

const LiveThreatTicker = () => {
  const { isPremium } = useAuth();
  const { data: events = [] } = useEvents(undefined, isPremium);

  const tickerItems = useMemo(() => {
    const now = Date.now();
    return events
      .filter((e) => now - new Date(e.occurred_at).getTime() < 86400000)
      .sort((a, b) => new Date(b.occurred_at).getTime() - new Date(a.occurred_at).getTime())
      .slice(0, 20)
      .map((e) => {
        const mins = Math.round((now - new Date(e.occurred_at).getTime()) / 60000);
        const timeAgo = mins < 60 ? `${mins}m ago` : `${Math.round(mins / 60)}h ago`;
        const icon = EVENT_ICONS[e.event_type] || "⚠️";
        const location = [e.city, e.country].filter(Boolean).join(", ");
        return `${icon} ${e.event_type.replace("_", " ")} — ${location || "Unknown"} (${timeAgo})`;
      });
  }, [events]);

  if (tickerItems.length === 0) return null;

  // Duplicate items for seamless loop
  const allItems = [...tickerItems, ...tickerItems];

  return (
    <div className="overflow-hidden border-b border-border bg-card/50">
      <div className="flex animate-ticker whitespace-nowrap py-1.5 sm:py-2">
        {allItems.map((item, i) => (
          <span
            key={i}
            className="mx-3 sm:mx-6 inline-block text-[10px] sm:text-xs font-mono text-muted-foreground"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default LiveThreatTicker;
